import React from "react";
import { Dialog } from "@headlessui/react";
import { MdClose } from "react-icons/md";
import Button from "../ui/Button";
import Input from "../ui/Input";
import InlineLoader from "../loader/InlineLoader";
import Moment from "react-moment";

const ApproveRejectModal = ({
  isOpen,
  onClose,
  action,
  isLoading,
  employeeName,
  attendanceDate,
  attendanceMonth,
  attendanceYear,
  control,
  handleSubmit,
  onConfirm,
  rejectReason,
}) => {
  const isApprove = action === "approve";

  const formatAttendanceDate = (date, month, year) => {
    return `${date}/${month}/${year}`;
  };

  const getAttendanceDateForMoment = (date, month, year) => {
    return new Date(`${year}-${month}-${date}`);
  };

  const attendanceDateString =
    attendanceDate && attendanceMonth && attendanceYear
      ? formatAttendanceDate(attendanceDate, attendanceMonth, attendanceYear)
      : "";

  const attendanceDayDate =
    attendanceDate && attendanceMonth && attendanceYear
      ? getAttendanceDateForMoment(attendanceDate, attendanceMonth, attendanceYear)
      : null;

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      className="fixed inset-0 z-[1002] overflow-y-auto"
    >
      <div className="flex min-h-screen items-center justify-center p-4">
        <Dialog.Overlay className="fixed inset-0 bg-black opacity-50" />

        <div className="relative bg-white rounded-lg max-w-md w-full">
          <div className="flex items-center justify-between p-4 border-b">
            <Dialog.Title className="text-lg font-semibold">
              {isApprove ? "Approve Request" : "Reject Request"}
            </Dialog.Title>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
              disabled={isLoading}
            >
              <MdClose className="w-6 h-6" />
            </button>
          </div>

          <form
            onSubmit={handleSubmit(onConfirm)}
            className="p-6 space-y-4"
          >
            <div>
              <p className="text-sm text-gray-600 mb-2">
                {isApprove
                  ? `Are you sure you want to approve this regularization request for `
                  : `Are you sure you want to reject this regularization request for `}
                <span className="font-semibold">{employeeName}</span>
                {attendanceDateString && (
                  <>
                    {" "}
                    on{" "}
                    <span className="font-semibold">
                      {attendanceDateString}
                    </span>
                    {attendanceDayDate && (
                      <>
                        {" "}
                        (
                        <span className="font-semibold">
                          <Moment date={attendanceDayDate} format="dddd" />
                        </span>
                        )
                      </>
                    )}
                  </>
                )}
                ?
              </p>
            </div>

            {!isApprove && (
              <Input
                control={control}
                name="reject_reason"
                label="Reason for Rejection"
                isTextarea
                rules={{ required: "Reason for rejection is required" }}
                placeholder="Please provide a reason for rejecting this request"
                disabled={isLoading}
              />
            )}

            <div className="flex justify-end space-x-3 pt-4">
              <Button
                type="button"
                variant="outline"
                onClick={onClose}
                disabled={isLoading}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant={isApprove ? "success" : "destructive"}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <InlineLoader className="mr-2" />
                    {isApprove ? "Approving..." : "Rejecting..."}
                  </>
                ) : isApprove ? (
                  "Approve"
                ) : (
                  "Reject"
                )}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Dialog>
  );
};

export default ApproveRejectModal;
